<template>
  <div class="text-center py-5">
    <img
        class="w-10 mx-auto"
        src="@/assets/img/illustrations/empty.svg"
        alt="sidebar_illustration"
    />
    <p class="font-weight-bold mb-0">Data not found</p>
  </div>
</template>

<script>
export default {
  name: 'empty-state'
}
</script>

<style>

</style>